module.exports = "\n<div class=\"container\">\n   Les statistiques d'un événement\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/stats-detail/stats-detail.component.html
// module id = 251
// module chunks = 0